export default {
  url_not_valid: "The url is not valid",
  email_invalid: "Email is invalid",
  required: "This field is required",
  phone_invalid: "Phone is invalid",
  uuid_invalid: "Uuid format is invalid",
  max_number_value: "The maximum value is {{value}}",
  min_number_value: "The minimum value is {{value}}",
  max_count: "The Maximum count of this field is {{count}}",
  ip_not_valid: "IP is not valid",
  host_not_valid: "Host is invalid",
  port_not_valid: "Port is invalid",
  host_and_ip_invalid: "IP address or Host is invalid",
};
